module.exports = __webpack_public_path__ + "img/kiosk-map-wayfinder-directory.577a9d67.webp";